import type { PortalWidget, PortalWidgetStatus } from "@entrilia/shared/api/portalWidgetsTypes";
import { combineComparers, priorityComparer } from "@entrilia/shared/utilities/arrayHelper";
import type { InvestorPortalFeature } from "../../../../api/types/investorPortalTypes";
import type { PortalPageStatus } from "../pages/portalPageStatusHelper";

export const getRelevantWidgetsForPage = (
  page: InvestorPortalFeature,
  allWidgets: PortalWidget[],
  newsEnabled: boolean
): PortalWidget[] => {
  if (page === "Dashboards") {
    return allWidgets
      .filter(
        (w) =>
          w.predefinedType === "Balance" ||
          w.predefinedType === "CashFlows" ||
          (w.predefinedType === "News" && newsEnabled) ||
          !w.predefinedType
      )
      .sort(
        combineComparers(
          priorityComparer((w) => w.predefinedType === "News"),
          priorityComparer((w) => w.predefinedType === "Balance"),
          priorityComparer((w) => w.predefinedType === "CashFlows")
        )
      );
  }

  if (page === "PortfolioCompanies") {
    return allWidgets.filter((w) => w.predefinedType === "Portfolio");
  }

  return [];
};

export type WidgetDataSourceType = "SystemReport" | "CashFlowTransactions" | "InvestorCommunications";

export const getWidgetDataSourceType = (widget: PortalWidget): WidgetDataSourceType => {
  if (widget.predefinedType === "CashFlows") {
    return "CashFlowTransactions";
  }
  if (widget.predefinedType === "News") {
    return "InvestorCommunications";
  }
  return "SystemReport";
};

export const getAvailableWidgetStatuses = (pageStatus: PortalPageStatus): PortalWidgetStatus[] => {
  switch (pageStatus) {
    case "live":
      return ["Off", "Preview", "Live"];
    case "preview":
      return ["Off", "Preview"];
    case "off":
    default:
      return ["Off"];
  }
};

const portalPageStatusRank: Record<PortalPageStatus, number> = { off: 0, preview: 1, live: 2 };

export const getWidgetPageStatus = (
  widget: PortalWidget,
  pageStatus: PortalPageStatus,
  newsPageStatus: PortalPageStatus
): PortalPageStatus =>
  widget.predefinedType === "News" && portalPageStatusRank[newsPageStatus] < portalPageStatusRank[pageStatus]
    ? newsPageStatus
    : pageStatus;
